import { PropsWithChildren } from 'react'
import { observer } from 'mobx-react-lite'
import { useLayout } from 'stores/LayoutStore'
import { Portal } from 'components/Portal/Portal'

export const WriterToolbar = observer(({ children }: PropsWithChildren) => {
  const layout = useLayout()

  if (!layout.writerToolbar) return null

  return <Portal container={layout.writerToolbar}>{children}</Portal>
})
